/* eslint-disable jsx-a11y/anchor-is-valid */
import classnames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import PropTypes from "prop-types";
import { isTires } from "util/category/is-tires";
import { isWheels } from "util/category/is-wheels";
import { toLowerCase } from "util/lodash/toLowerCase";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import { ChevronRight } from "lucide-react";
import styles from "./breadCrumbItemComponent.module.scss";

const propTypes = {
  title: PropTypes.string.isRequired,
};

export default function BreadcrumbItem(props: any) {
  const {
    className,
    title,
    onClick,
    style,
    url,
    isLast,
    showSeparator = false,
    categoryObj,
  } = props;

  const seprator = !isLast && showSeparator ? (
    <div className="d-flex" style={{ margin: "auto 5px" }}>
      <ChevronRight color="#6a7282" size={15} />
    </div>
  ) : <span />;

  const displayTitle = title?.replace(/parts|& parts/i, "");

  if (url && !onClick) {
    const customSizes = getCustomSizeQuery();
    const { href, asPath } = getHrefAndPath({ asPath: url, query: { ...customSizes } });
    let updatedHref = url; let
      updatedAsPath = url;
    if (customSizes && Object.keys(customSizes).length > 0 && (isTires(toLowerCase(categoryObj?.tier1)) || isWheels(toLowerCase(categoryObj?.tier1)))) {
      updatedHref = href;
      updatedAsPath = asPath;
    }

    return (
      <li
        className={classnames({
          "breadcrumb-item": true,
        }, className)}
        style={style}
      >

        <Link href={updatedHref} as={updatedAsPath} title={displayTitle}>

          <div className="title">
            {displayTitle}
          </div>
          {seprator}

        </Link>
      </li>
    );
  }

  return (
    <li
      className={classnames({
        [styles.disable_breadcrumb]: !url && !categoryObj,
        "breadcrumb-item": true,
      }, className)}
      style={style}
    >

      <>
        <a onClick={onClick}>
          <PAText
            fontSize={FONT_SIZE[0]}
            component="div"
            className={`title ${isLast ? styles.last_title : ""}`}
            title={displayTitle}
          >
            {displayTitle}
          </PAText>
          {seprator}
        </a>
      </>
    </li>
  );
}

BreadcrumbItem.propTypes = propTypes;
